import axios from "axios";

import { AppDispatch } from "../../reducer/store";
import {
  reducerGetCheckStatusCharts,
  reducerGetRateStatusCharts,
  reducerGetSkuAverageCharts,
  reducerGetDynamicsCharts,
  reducerGetReportsCharts,
  reducerGetActionsCharts,
  reducerGetVisitsCharts,
  reducerGetFacingCharts,
  reducerGetModalFilter,
  reducerGetOssCharts,
  reducerGetDesktops,
  reducerGroups
} from "../../reducer/charts/reducer/reducerCharts";
import { getToken } from "../axiosToken";

import { createMultiselectOptionsByList, createMultiselectOptionsByPos, createMultiselectOptionsBychains } from "../../../utils/createOptions";
import { defaultFilter, getSortedValue } from "../../../utils/chartsData";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const actionAnalyticFilters = (pageId: string, list: string[], isModal: boolean) => async (dispatch: AppDispatch, getState: () => any) => {
  const { token } = await getToken();
  axios.defaults.headers.common["Authorization"] = token;
  const store = getState();
  const filters = store.charts.chartsList;
  const dates = isModal ? filters.modalFilters : filters.desktopInputValues[pageId] ? filters.desktopInputValues[pageId].generalFilters : defaultFilter;

  try {
    const promises = list.map(async (el: string) => {
      const response = await axios.post(`${BASE_URL}/json/reports/analytics/sku/filter/values/${el}`,
        dates
      );
      return {
        [el]: el !== 'pos' && el !== 'chain'
          ? createMultiselectOptionsByList(response.data)
          : el === 'chain' ? createMultiselectOptionsBychains(response.data) : createMultiselectOptionsByPos(response.data)
      };
    });

    const results = await Promise.all(promises);

    const groups = Object.assign({}, ...results);

    if (isModal) {
      dispatch(reducerGetModalFilter(groups));
    } else {
      dispatch(reducerGroups(groups));
    }
  } catch (error) {
    console.log(error);
  }
};

export const actionGetUserReports = () => async (dispatch: AppDispatch, getState: () => any) => {
  const { token } = await getToken();
  axios.defaults.headers.common["Authorization"] = token;
  const store = getState();
  const filters = store.charts.chartsList.inputValues;

  try {
    const response = await axios.post(`${BASE_URL}/json/reports/list`, {
      ...filters,
      limit: 10,
      page: 1,
    });
    return response.data.data[0];
  } catch (e: any) {
    console.log(e);
  }
};

export const actionTest = () => async (dispatch: AppDispatch, getState: () => any) => {
  console.log(1111);
};

export const actionGetDesktop =
  (key: string) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const response = await axios.get(`${BASE_URL}/json/auth/config?key=${key}`);

      dispatch(reducerGetDesktops(response.data));
      return response.data;
    } catch {
      console.log('err');
    };
  };

export const actionAddDesktop = () => async (dispatch: AppDispatch, getState: () => any) => {
  const store = getState();
  const { token } = await getToken();
  axios.defaults.headers.common["Authorization"] = token;
  const desktopList = store.charts.chartsList.desktopList;
  const orders = store.charts.chartsList.reorderedOptions;
  const defaultDesktop = store.charts.chartsList.defaultDesktop;
  const settingCharts = store.charts.chartsList.settingCharts;

  axios.post(`${BASE_URL}/json/auth/config/update?key=customerReport`, {
    defaultDesktop,
    settingCharts,
    desktopList,
    orders
  });
};

export const actionAnalyticOos = (id: number, pageId: string | undefined) => async (dispatch: AppDispatch, getState: () => any) => {
  const { token } = await getToken();
  axios.defaults.headers.common["Authorization"] = token;
  const store = getState();
  const filters = store.charts.chartsList.desktopInputValues[pageId || 0][id] || defaultFilter;

  try {
    const response = await axios.post(`${BASE_URL}/json/reports/analytics/oos/${filters.group.value}`, {
      ...filters,
      limit: 9000,
    });

    let sortedRes: any = [];
    const entries = Object.entries(response.data);

    const sortData = (sortedValues: number[]) => {
      return [...entries].sort((a, b) => {
        const indexA = sortedValues.indexOf(Number(a[0]));
        const indexB = sortedValues.indexOf(Number(b[0]));
        return indexA - indexB;
      });
    };

    switch (filters.group.value) {
      case '0':
      case '7':
      case '8':
      case '9':
        sortedRes = entries.sort((a: any, b: any) => {
          const dateA = new Date(a[0]).getTime();
          const dateB = new Date(b[0]).getTime();

          return dateA - dateB;
        });
        break;
      case '1':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.contractsOptions));
        break;
      case '2':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.projectOptions));
        break;
      case '3':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.chainsOptions));
        break;
      case '4':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.areasOptions));
        break;
      case '5':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.regionsOptions));
        break;
      default:
        sortedRes = response.data;
    };

    dispatch(reducerGetOssCharts({ data: sortedRes, id, pageId: pageId || 0 }));
    return response.data;
  } catch (e: any) {
    console.log(e);
    dispatch(reducerGetOssCharts({ id, data: [], pageId: pageId || 0 }));
  }
};

export const actionAnalyticVisit = (id: number, pageId: string | undefined) => async (dispatch: AppDispatch, getState: () => any) => {
  const { token } = await getToken();
  axios.defaults.headers.common["Authorization"] = token;
  const store = getState();
  const filters = store.charts.chartsList.desktopInputValues[pageId || 0][id] || defaultFilter;

  try {
    const response = await axios.post(`${BASE_URL}/json/reports/analytics/visit/${filters.group.value}`, {
      ...filters,
      limit: 9000,
    });

    let sortedRes: any = [];

    const sortData = (sortedValues: number[]) => {
      return [...response.data].sort((a, b) => {
        const indexA = sortedValues.indexOf(Number(a.groupingKey));
        const indexB = sortedValues.indexOf(Number(b.groupingKey));
        return indexA - indexB;
      });
    };

    switch (filters.group.value) {
      case '0':
        sortedRes = response.data.sort((a: any, b: any) => {
          return new Date(a.date).getTime() - new Date(b.date).getTime();
        });
        break;
      case '1':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.contractsOptions));
        break;
      case '2':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.projectOptions));
        break;
      case '3':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.chainsOptions));
        break;
      case '4':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.areasOptions));
        break;
      case '5':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.regionsOptions));
        break;
      default:
        sortedRes = response.data;
    };

    dispatch(reducerGetVisitsCharts({ data: sortedRes, id, pageId: pageId || 0 }));
  } catch (e: any) {
    console.log(e);
    dispatch(reducerGetVisitsCharts({ data: [], id, pageId }));
  }
};

export const actionAnalyticSkuAverage = (id: number, pageId: string | undefined) => async (dispatch: AppDispatch, getState: () => any) => {
  const { token } = await getToken();
  axios.defaults.headers.common["Authorization"] = token;
  const store = getState();
  const filters = store.charts.chartsList.desktopInputValues[pageId || 0][id] || defaultFilter;

  try {
    const response = await axios.post(`${BASE_URL}/json/reports/analytics/skuAverage/${filters.group.value}`, {
      ...filters,
      limit: 9000,
    });

    let sortedRes: any = [];

    const sortData = (sortedValues: number[]) => {
      return [...response.data].sort((a, b) => {
        const indexA = sortedValues.indexOf(Number(Object.keys(a)[0]));
        const indexB = sortedValues.indexOf(Number(Object.keys(b)[0]));
        return indexA - indexB;
      });
    };

    switch (filters.group.value) {
      case '0':
        sortedRes = response.data.sort((a: any, b: any) => {
          return new Date(a.date).getTime() - new Date(b.date).getTime();
        });
        break;
      case '1':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.contractsOptions));
        break;
      case '2':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.projectOptions));
        break;
      case '3':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.chainsOptions));
        break;
      case '4':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.areasOptions));
        break;
      case '5':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.regionsOptions));
        break;
      default:
        sortedRes = response.data;
    };

    dispatch(reducerGetSkuAverageCharts({ id, data: sortedRes, pageId: pageId || 0 }));
  } catch (e: any) {
    console.log(e);
    dispatch(reducerGetSkuAverageCharts({ id, data: [], pageId: pageId || 0 }));
  }
};

export const actionsAnalyticActions = (id: number, pageId: string | undefined) => async (dispatch: AppDispatch, getState: () => any) => {
  const { token } = await getToken();
  axios.defaults.headers.common["Authorization"] = token;
  const store = getState();
  const filters = store.charts.chartsList.desktopInputValues[pageId || 0][id] || { defaultFilter, group: { value: '6', label: 'По сети' } };

  try {
    const response = await axios.post(`${BASE_URL}/json/reports/analytics/actions/${filters.group.value}`, {
      ...filters,
      limit: 9000,
    });

    let sortedRes: any = [];

    const sortData = (sortedValues: number[]) => {
      return [...response.data].sort((a, b) => {
        const indexA = sortedValues.indexOf(Number(Object.keys(a.groupedPercentages)[0]));
        const indexB = sortedValues.indexOf(Number(Object.keys(b.groupedPercentages)[0]));
        return indexA - indexB;
      });
    };

    switch (filters.group.value && response.data > 0) {
      case '0':
        sortedRes = response.data.sort((a: any, b: any) => {
          return new Date(Object.keys(a.groupedCompletion)[0]).getTime() - new Date(Object.keys(b.groupedCompletion)[0]).getTime();
        });
        break;
      case '4':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.contractsOptions));
        break;
      case '5':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.projectOptions));
        break;
      case '6':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.chainsOptions));
        break;
      case '7':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.areasOptions));
        break;
      case '8':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.regionsOptions));
        break;
      case '9':
        sortedRes = [...response.data].sort((a, b) => {
          console.log(a);
          const keysA = Object.keys(a.groupedData);
          const keysB = Object.keys(b.groupedData);

          if (keysA.length === 0 && keysB.length === 0) return 0;
          if (keysA.length === 0) return 1;
          if (keysB.length === 0) return -1;

          const firstKeyA = keysA[0];
          const firstKeyB = keysB[0];

          return firstKeyA.localeCompare(firstKeyB);
        });
        break;
      default:
        sortedRes = response.data;
    };

    dispatch(reducerGetActionsCharts({ id, data: sortedRes, pageId: pageId || 0 }));
  } catch (e: any) {
    console.log(e);
    dispatch(reducerGetActionsCharts({ id, data: [], pageId: pageId || 0 }));
  }
};

export const actionsAnalyticRateStatus = (id: number, pageId: string | undefined) => async (dispatch: AppDispatch, getState: () => any) => {
  const { token } = await getToken();
  axios.defaults.headers.common["Authorization"] = token;
  const store = getState();
  const filters = store.charts.chartsList.desktopInputValues[pageId || 0][id] || defaultFilter;

  try {
    const response = await axios.post(`${BASE_URL}/json/reports/analytics/rate-status/${filters.group.value}`, {
      ...filters,
      limit: 9000,
    });

    let sortedRes: any = [];

    const sortData = (sortedValues: number[]) => {
      return [...response.data].sort((a, b) => {
        let indexA, indexB;

        if (filters.group.value === '11') {
          indexA = sortedValues.indexOf(a.groupingKey);
          indexB = sortedValues.indexOf(b.groupingKey);
        } else {
          indexA = sortedValues.indexOf(Number(a.groupingKey));
          indexB = sortedValues.indexOf(Number(b.groupingKey));
        }

        return indexA - indexB;
      });
    };

    switch (filters.group.value) {
      case '0':
        sortedRes = response.data.sort((a: any, b: any) => {
          return new Date(a.date).getTime() - new Date(b.date).getTime();
        });
        break;
      case '1':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.contractsOptions));
        break;
      case '2':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.projectOptions));
        break;
      case '3':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.chainsOptions));
        break;
      case '4':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.areasOptions));
        break;
      case '5':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.regionsOptions));
        break;
      case '11':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.rateOptions));
        break;
      default:
        sortedRes = response.data;
    };

    dispatch(reducerGetRateStatusCharts({ id, data: sortedRes, pageId: pageId || 0 }));
  } catch (e: any) {
    console.log(e);
    dispatch(reducerGetRateStatusCharts({ id, data: [], pageId: pageId || 0 }));
  }
};

export const actionsAnalyticCheckStatus = (id: number, pageId: string | undefined) => async (dispatch: AppDispatch, getState: () => any) => {
  const { token } = await getToken();
  axios.defaults.headers.common["Authorization"] = token;
  const store = getState();
  const filters = store.charts.chartsList.desktopInputValues[pageId || 0][id] || defaultFilter;

  try {
    const response = await axios.post(`${BASE_URL}/json/reports/analytics/status/${filters.group.value}`, {
      ...filters,
      limit: 9000,
    });

    let sortedRes: any = [];

    const sortData = (sortedValues: number[]) => {
      return [...response.data].sort((a, b) => {
        let indexA, indexB;

        if (filters.group.value === '10') {
          indexA = sortedValues.indexOf(a.groupingKey);
          indexB = sortedValues.indexOf(b.groupingKey);
        } else {
          indexA = sortedValues.indexOf(Number(a.groupingKey));
          indexB = sortedValues.indexOf(Number(b.groupingKey));
        }

        return indexA - indexB;
      });
    };

    switch (filters.group.value) {
      case '0':
        sortedRes = response.data.sort((a: any, b: any) => {
          return new Date(a.date).getTime() - new Date(b.date).getTime();
        });
        break;
      case '1':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.contractsOptions));
        break;
      case '2':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.projectOptions));
        break;
      case '3':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.chainsOptions));
        break;
      case '4':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.areasOptions));
        break;
      case '5':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.regionsOptions));
        break;
      case '10':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.reviewOptions));
        break;
      default:
        sortedRes = response.data;
    };

    dispatch(reducerGetCheckStatusCharts({ id, data: sortedRes, pageId: pageId || 0 }));
  } catch (e: any) {
    console.log(e);
    dispatch(reducerGetCheckStatusCharts({ id, data: [], pageId: pageId || 0 }));
  }
};

export const actionsAnalyticFacing = (id: number, pageId: string | undefined) => async (dispatch: AppDispatch, getState: () => any) => {
  const { token } = await getToken();
  axios.defaults.headers.common["Authorization"] = token;
  const store = getState();
  const filters = store.charts.chartsList.desktopInputValues[pageId || 0][id] || defaultFilter;

  try {
    const response = await axios.post(`${BASE_URL}/json/reports/analytics/sku/max/${filters.group.value}`, {
      ...filters,
      limit: 9000,
    });

    let sortedRes: any = [];

    const sortData = (sortedValues: number[]) => {
      return [...response.data].sort((a, b) => {
        const indexA = sortedValues.indexOf(Number(a.dateSkuFaceData[0].grouped));
        const indexB = sortedValues.indexOf(Number(b.dateSkuFaceData[0].grouped));
        return indexA - indexB;
      });
    };

    switch (filters.group.value) {
      case '0':
        sortedRes = response.data.sort((a: any, b: any) => {
          return new Date(a.date).getTime() - new Date(b.date).getTime();
        });
        break;
      case '1':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.contractsOptions));
        break;
      case '2':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.projectOptions));
        break;
      case '3':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.chainsOptions));
        break;
      case '4':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.areasOptions));
        break;
      case '5':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.regionsOptions));
        break;
      case '10':
      case '13':
        sortedRes = response.data.sort((a: any, b: any) => {
          const groupedA = a.dateSkuFaceData[0].grouped;
          const groupedB = b.dateSkuFaceData[0].grouped;

          return groupedA.localeCompare(groupedB);
        });
        break;
      case '11':
      case '14':
        sortedRes = response.data.sort((a: any, b: any) => {
          const groupedA = a.dateSkuFaceData[0].skuFaceSums[0].skuName;
          const groupedB = b.dateSkuFaceData[0].skuFaceSums[0].skuName;

          return groupedA.localeCompare(groupedB);
        });
        break;
      default:
        sortedRes = response.data;
    };
    dispatch(reducerGetFacingCharts({ id, data: sortedRes, pageId: pageId || 0 }));
  } catch (e: any) {
    console.log(e);
    dispatch(reducerGetFacingCharts({ id, data: [], pageId: pageId || 0 }));
  }
};

export const actionsAnalyticStatusCity = (id: number, pageId: string | undefined) => async (dispatch: AppDispatch, getState: () => any) => {
  const { token } = await getToken();
  axios.defaults.headers.common["Authorization"] = token;
  const store = getState();
  const filters = store.charts.chartsList.desktopInputValues[pageId || 0][id] || defaultFilter;

  try {
    const response = await axios.post(`${BASE_URL}/json/reports/analytics/status-with-city/${filters.group.value}`, {
      ...filters,
      limit: 9000,
    });

    let sortedRes: any = [];

    const sortData = (sortedValues: number[]) => {
      return [...response.data].sort((a, b) => {
        const indexA = sortedValues.indexOf(Number(a.groupingKey));
        const indexB = sortedValues.indexOf(Number(b.groupingKey));
        return indexA - indexB;
      });
    };

    switch (filters.group.value && response.data.length > 0) {
      case '0':
        sortedRes = response.data.sort((a: any, b: any) => {
          return new Date(a.date).getTime() - new Date(b.date).getTime();
        });
        break;
      case '1':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.contractsOptions));
        break;
      case '2':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.projectOptions));
        break;
      case '3':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.chainsOptions));
        break;
      case '4':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.areasOptions));
        break;
      case '5':
        sortedRes = sortData(getSortedValue(store.userReports.userReports.regionsOptions));
        break;
      default:
        sortedRes = response.data;
    };

    dispatch(reducerGetDynamicsCharts({ id, data: sortedRes, pageId: pageId || 0 }));
  } catch (e: any) {
    console.log(e);
    dispatch(reducerGetDynamicsCharts({ id, data: [], pageId: pageId || 0 }));
  }
};

export const actionsReportsChart = (id: number, pageId: string | undefined) => async (dispatch: AppDispatch, getState: () => any) => {
  const { token } = await getToken();
  axios.defaults.headers.common["Authorization"] = token;
  const store = getState();
  const filters = store.charts.chartsList.desktopInputValues[pageId || 0][id] || defaultFilter;

  try {
    const response = await axios.post(`${BASE_URL}/json/reports/analytics/indicator/${filters.status || 'RATE_STATUS'}/0`, {
      ...filters,
      limit: 9000,
    });

    dispatch(reducerGetReportsCharts({ id, data: response.data, pageId: pageId || 0 }));
  } catch (e: any) {
    console.log(e);
    dispatch(reducerGetReportsCharts({ id, data: [], pageId: pageId || 0 }));
  }
};